<template>
  <!-- 添加编辑弹窗 -->
  <el-dialog
    title="一级分类"
    :visible.sync="categoryShow"
    width="800px"
    class="firstChild"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <div class="diabox">
      <el-form :model="info" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="排序">
          <el-input-number
            v-model="info.sort"
            step-strictly
            :step="1"
            :min="0"
            :max="1000000000"
            :controls="false"
            placeholder="请输入排序"
          ></el-input-number>
          <span style="margin-left: 10px; color: #999"
            >数字越大，排名越靠前,如果为空，默认排序方式为创建时间</span
          >
        </el-form-item>

        <el-form-item label="分类名称" prop="category_name">
          <el-input
            v-model="info.category_name"
            maxlength="20"
            style="width: 280px"
            placeholder="不超过20个字"
          ></el-input>
        </el-form-item>

        <el-form-item label="是否显示">
          <el-radio v-model="info.is_visible" :label="1">是</el-radio>
          <el-radio v-model="info.is_visible" :label="0">否</el-radio>
        </el-form-item>

        <el-form-item label="当前分类类型" prop="category_type">
          <el-checkbox-group v-model="info.category_type">
            <el-checkbox :label="1" name="type">互联网医院分类</el-checkbox>
            <el-checkbox :label="2" name="type">平台分类</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="关联科室" prop="department_id">
          <el-select
            v-model="info.department_id"
            placeholder="请选择关联科室"
            style="width: 280px"
            clearable
          >
            <el-option
              v-for="item in departmentList"
              :key="item.department_id"
              :label="item.department_name"
              :value="item.department_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="分类logo" prop="category_pic">
          <el-upload
            name="image"
            accept=".png,.jpeg,.jpg"
            :show-file-list="false"
            :http-request="uploadImg"
            action="category_pic"
          >
            <el-button slot="trigger" type="text">上传本地图片</el-button>

            <el-button
              style="margin-left: 10px"
              type="text"
              @click="chooseHistoryImg(1)"
              >选择历史图片</el-button
            >
            <span style="color: #999; font-size: 12px; margin-left: 10px"
              >尽量上传方形图片，大小在5MB以内，支持png,jpeg,jpg格式，最多可上传1张</span
            >
          </el-upload>
        </el-form-item>
        <div class="box" v-show="info.category_pic">
          <img :src="info.category_pic_str" />

          <el-upload
            :show-file-list="false"
            :http-request="uploadImg"
            action="category_pic"
          >
            <div class="shadow column-center column">
              <div>
                <i
                  class="el-icon-search"
                  @click.stop="showImg(info.category_pic_str)"
                ></i>

                <i class="el-icon-delete" @click.stop="delImg(1)"></i>
              </div>
            </div>
          </el-upload>
        </div>
        <el-form-item label="展示banner" prop="category_banner">
          <el-upload
            name="image"
            accept=".png,.jpeg,.jpg"
            :show-file-list="false"
            :http-request="uploadImg"
            action="category_banner"
          >
            <el-button slot="trigger" type="text">上传本地图片</el-button>

            <el-button
              style="margin-left: 10px"
              type="text"
              @click="chooseHistoryImg(2)"
              >选择历史图片</el-button
            >
            <span style="color: #999; font-size: 12px; margin-left: 10px"
              >尽量上传方形图片，大小在5MB以内，支持png,jpeg,jpg格式，最多可上传1张</span
            >
          </el-upload>
        </el-form-item>
        <div class="box" v-show="info.category_banner">
          <img :src="info.category_banner_str" />

          <el-upload
            :show-file-list="false"
            :http-request="uploadImg"
            action="category_banner"
          >
            <div class="shadow column-center column">
              <div>
                <i
                  class="el-icon-search"
                  @click.stop="showImg(info.category_banner_str)"
                ></i>

                <i class="el-icon-delete" @click.stop="delImg(2)"></i>
              </div>
            </div>
          </el-upload>
        </div>
        <el-form-item label="海报分享图" prop="share_poster">
          <el-upload
            name="image"
            accept=".png,.jpeg,.jpg"
            :show-file-list="false"
            :http-request="uploadImg"
            action="share_poster"
          >
            <el-button slot="trigger" type="text">上传本地图片</el-button>
            <span style="color: #999; font-size: 12px; margin-left: 10px"
              >尽量上传方形图片，大小在5MB以内，支持png,jpeg,jpg格式，最多可上传1张</span
            >
          </el-upload>
        </el-form-item>
        <div class="box" v-show="info.share_poster">
          <img :src="info.share_poster_str" />

          <el-upload
            :show-file-list="false"
            :http-request="uploadImg"
            action="share_poster"
          >
            <div class="shadow column-center column">
              <div>
                <i
                  class="el-icon-search"
                  @click.stop="showImg(info.share_poster_str)"
                ></i>

                <i class="el-icon-delete" @click.stop="delImg(3)"></i>
              </div>
            </div>
          </el-upload>
        </div>
        <el-form-item label="分享卡片图">
          <el-upload
            name="image"
            accept=".png,.jpeg,.jpg"
            :show-file-list="false"
            :http-request="uploadImg"
            action="share_img"
          >
            <el-button slot="trigger" type="text">上传本地图片</el-button>
            <span style="color: #999; font-size: 12px; margin-left: 10px"
              >尽量上传方形图片，大小在5MB以内，支持png,jpeg,jpg格式，最多可上传1张</span
            >
          </el-upload>
        </el-form-item>
        <div class="box" v-show="info.share_img">
          <img :src="info.share_img_str" />

          <el-upload
            :show-file-list="false"
            :http-request="uploadImg"
            action="share_img"
          >
            <div class="shadow column-center column">
              <div>
                <i
                  class="el-icon-search"
                  @click.stop="showImg(info.share_img_str)"
                ></i>

                <i class="el-icon-delete" @click.stop="delImg(4)"></i>
              </div>
            </div>
          </el-upload>
        </div>
        <el-form-item
          label="置顶商品"
          prop="goods_list"
          v-if="info.category_id"
        >
          <el-button
            style="margin-left: 10px"
            type="text"
            @click="chooseGoodShow = true"
            >选择商品</el-button
          >
        </el-form-item>
        <div
          v-for="(item, index) in info.goods_list"
          :key="item.goods_id"
          class="goods_list"
        >
          <el-form-item
            label-width="0"
            :prop="'goods_list.' + index + '.image_str'"
            :rules="{
              required: false,
              message: '请选择置顶图片',
              trigger: ['change'],
            }"
          >
            <div class="flex align-center">
              <!-- <div style="height:115px" >
                <img :src="item.img_url" class="img1" />
              </div>-->

              <el-upload
                name="image"
                accept=".png,.jpeg,.jpg"
                :show-file-list="false"
                :http-request="
                  (params) => {
                    uploadImg(params, item);
                  }
                "
                action="goods_list"
              >
                <el-button
                  style="margin-left: 10px"
                  type="text"
                  v-show="!item.image_str"
                  >上传置顶图片</el-button
                >
                <img :src="item.image_str" v-show="item.image_str" />
              </el-upload>
              <div class="text">{{ item.goods_name }}</div>
              <i class="el-icon-delete" @click="delGoods(item)"></i>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div style="text-align: right; padding: 0 50px 20px 0">
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="close" style="width: 92px"
          >取消</el-button
        >
        <el-button type="primary" @click="submit" style="width: 92px"
          >保 存</el-button
        >
      </span>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgList"
    />
    <!-- //历史图片 -->
    <HistoryImg
      v-if="historyImgShow"
      @chooseImg="chooseImg"
      :type="historyType"
      @close="historyImgShow = false"
    ></HistoryImg>

    <!-- 上传置顶商品 -->
    <ChooseGood
      :category_id="info.category_id || 0"
      v-if="chooseGoodShow"
      @close="chooseGoodShow = false"
      @checkGoods="checkGoods"
    ></ChooseGood>
  </el-dialog>
</template>

<script>
import HistoryImg from "./HistoryImg";
import ChooseGood from "./ChooseGood";
import { uploadImg, getImgUrl } from "../../../service/common/constant";
import doctor from "@/api/doctor";
export default {
  name: "firstChild",
  data() {
    return {
      categoryShow: true,
      info: {
        sort: undefined,
        category_name: "",
        is_visible: 1,
        category_pic: "",
        category_banner: "",
        share_img: "",
        share_poster: "",
        goods_list: [],
        category_type: [],
        department_id: "",
      },
      departmentList: [],
      rules: {
        category_name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
        ],
        category_type: [
          {
            type: "array",
            required: true,
            min: 1,
            message: "请至少选择一个分类类型",
            trigger: "change",
          },
        ],
        department_id: [
          { required: true, message: "请选择关联科室", trigger: "change" },
        ],
        category_pic: [
          { required: true, message: "请上传分类图片", trigger: "blur" },
        ],
        category_banner: [
          { required: true, message: "请上传分类banner", trigger: "blur" },
        ],
        share_poster: [
          { required: true, message: "请上传海报分享图", trigger: "blur" },
        ],
        goods_list: [
          // { required: true, message: "请选择置顶商品", trigger: "blur" }
        ],
      },
      imgList: [],
      showViewer: false,
      historyImgShow: false,
      historyType: "", //历史图片选择的类型
      chooseGoodShow: false,
    };
  },
  props: {
    oldInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  components: {
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer"),
    HistoryImg,
    ChooseGood,
  },
  created() {
    console.log(this.oldInfo);
    // 获取科室列表
    this.getDepartmentList();
    // 初始化表单数据
    this.initFormData();
  },
  methods: {
    // 获取科室列表
    getDepartmentList() {
      doctor.getDepartmentList().then((res) => {
        if (res.code === 0) {
          this.departmentList = res.data.list || [];
        }
      });
    },
    // 初始化表单数据
    initFormData() {
      // 处理分类类型：如果是字符串，转换为数组；如果是数组，直接使用；否则为空数组
      let categoryType = [];
      if (this.oldInfo.category_type) {
        if (Array.isArray(this.oldInfo.category_type)) {
          categoryType = this.oldInfo.category_type;
        } else if (typeof this.oldInfo.category_type === "string") {
          // 如果是字符串，可能是逗号分隔的字符串
          categoryType = this.oldInfo.category_type
            .split(",")
            .map((item) => Number(item.trim()))
            .filter((item) => !isNaN(item));
        } else {
          categoryType = [Number(this.oldInfo.category_type)];
        }
      }

      this.info = {
        sort: this.oldInfo.sort || undefined,
        category_name: this.oldInfo.category_name || "",
        is_visible: this.oldInfo.is_visible == 0 ? 0 : 1,
        category_pic: this.oldInfo.category_pic || "",
        category_pic_str: this.oldInfo.category_pic_str || "",
        category_banner: this.oldInfo.category_banner || "",
        category_banner_str: this.oldInfo.category_banner_str || "",
        share_img: this.oldInfo.share_img || "",
        share_img_str: this.oldInfo.share_img_str || "",
        share_poster: this.oldInfo.share_poster || "",
        share_poster_str: this.oldInfo.share_poster_str || "",
        category_id: this.oldInfo.category_id || "",
        goods_list: this.oldInfo.goods_list || [],
        category_type: categoryType,
        department_id: this.oldInfo.department_id || "",
      };
    },
    close() {
      this.$emit("close");
    },
    //上传图片
    uploadImg(params, item) {
      let file = params.file;
      uploadImg(file)
        .then((res) => {
          if (params.action == "category_pic") {
            this.info.category_pic_str = res.data.path;
            this.info.category_pic = res.data.pic;
          } else if (params.action == "category_banner") {
            this.info.category_banner_str = res.data.path;
            this.info.category_banner = res.data.pic;
          } else if (params.action == "share_img") {
            this.info.share_img_str = res.data.path;
            this.info.share_img = res.data.pic;
          } else if (params.action == "share_poster") {
            this.info.share_poster_str = res.data.path;
            this.info.share_poster = res.data.pic;
          } else if (params.action == "goods_list") {
            let index = this.info.goods_list.findIndex((ele) => {
              return ele.goods_id == item.goods_id;
            });
            this.$set(this.info.goods_list[index], "image", res.data.pic);
            this.$set(this.info.goods_list[index], "image_str", res.data.path);
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //前往选择历史图片
    chooseHistoryImg(type) {
      this.historyType = type;
      this.historyImgShow = true;
    },
    chooseImg(item) {
      if (this.historyType == 1) {
        this.info.category_pic = item.pic_url;
        this.info.category_pic_str = item.pic_url_str;
      } else if (this.historyType == 2) {
        this.info.category_banner = item.pic_url;
        this.info.category_banner_str = item.pic_url_str;
      }
      this.historyImgShow = false;
    },
    //查看图片
    showImg(item) {
      this.imgList = [item];
      this.showViewer = true;
    },
    //删除图片
    delImg(type) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          if (type == 1) {
            this.info.category_pic = "";
            this.info.category_pic_str = "";
          } else if (type == 2) {
            this.info.category_banner = "";
            this.info.category_banner_str = "";
          } else if (type == 3) {
            this.info.share_poster = "";
            this.info.share_poster_str = "";
          } else if (type == 4) {
            this.info.share_img = "";
            this.info.share_img_str = "";
          }
        })
        .catch(() => {});
    },
    //选择置顶商品
    checkGoods(goods) {
      goods.forEach((ele1) => {
        let index = this.info.goods_list.findIndex((ele2) => {
          return ele2.goods_id == ele1.goods_id;
        });
        if (index == -1) {
          ele1.image = "";
          ele1.image_str = "";
          this.info.goods_list.push(ele1);
        }
      });
      this.chooseGoodShow = false;
    },
    //删除置顶商品
    delGoods(item) {
      this.$confirm("确定删除吗？", "提示消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        let index = this.info.goods_list.findIndex((ele) => {
          return ele.goods_id == item.goods_id;
        });
        this.info.goods_list.splice(index, 1);
      });
    },
    submit() {
      let check = false;
      this.$refs.ruleForm.validate((valid) => {
        check = valid;
      });
      if (!check) {
        return;
      }
      let data = {
        sort: this.info.sort,
        category_name: this.info.category_name,
        is_visible: this.info.is_visible,
        category_pic: this.info.category_pic,
        category_banner: this.info.category_banner,
        share_img: this.info.share_img,
        share_poster: this.info.share_poster,
        category_type: Array.isArray(this.info.category_type)
          ? this.info.category_type.join(",")
          : this.info.category_type,
        department_id: this.info.department_id,
      };
      let url = "";
      if (this.info.category_id) {
        data.category_id = this.info.category_id;
        let list = [];
        this.info.goods_list.forEach((ele) => {
          list.push({ goods_id: ele.goods_id, image: ele.image });
        });
        data.goods_list = list;
        url = "platform/ManageGoods/editCategoryInfo";
      } else {
        url = "platform/ManageGoods/saveFirstCategoryInfo";
      }
      this.axios.post(url, data).then((res) => {
        this.$message.success("添加成功");
        this.$parent.getList();
        this.close();
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.diabox {
  padding: 20px 20px 0;
  overflow: auto;
  min-height: 50vh;
  max-height: 60vh;
}
.uploadimg {
  width: 200px;
  height: 200px;
  background-color: #fff;
  border: solid 1px #d6d6d6;
  overflow: hidden;
  box-sizing: border-box;
  .avatar {
    width: 200px;
    height: 200px;
  }
  .icobox {
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .uploader-icon {
    font-size: 30px;
    color: #d6d6d6;
  }
}
.tip {
  color: #999;
  margin: 15px 0;
}
.box {
  position: relative;
  padding-left: 100px;
  margin-top: -20px;
  &:hover .shadow {
    display: flex;
  }
  img {
    width: 200px;
    height: 200px;
  }
  .shadow {
    position: absolute;
    left: 100px;
    top: 0;
    width: 200px;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.6);
    display: none;
  }
  i + i {
    margin-left: 30px;
    color: #d44747;
  }
  i {
    color: #ffffff;
    font-size: 30px;
    text-align: center;
    cursor: pointer;
  }
}
.goods_list {
  height: 110px;
  margin-bottom: 5px;
  padding-left: 100px;

  img {
    height: 100px;
    width: auto;
    margin-right: 10px;
    font-size: 0;
  }
  .text {
    width: 400px;
  }
  i {
    color: red;
    font-size: 18px;
    margin-left: auto;
  }
}
</style>
<style lang="scss">
.firstChild {
  .el-input-number input {
    text-align: left !important;
  }
  .goods_list .el-upload {
    line-height: 0;
  }
}
</style>
